import {
  PendingCommissionDTO,
  ReferralDTO,
  ReferralSearchDTO,
} from '../../types';

export const PENDING_REFERRAL_TASK_PAGE_SIZE = 1000;

export type PendingReferralTaskKind =
  | 'needs_referee_acceptance'
  | 'waiting_on_referee';

export type PendingTaskKind = PendingReferralTaskKind | 'commission_due';

export interface PendingReferralTask {
  kind: PendingReferralTaskKind;
  referral: ReferralDTO;
}

export interface PendingCommissionTask {
  kind: 'commission_due';
  commission: PendingCommissionDTO;
}

export function buildNeedsRefereeAcceptanceSearchParams(
  organizationId: string,
  page: number
): ReferralSearchDTO {
  return {
    page,
    limit: PENDING_REFERRAL_TASK_PAGE_SIZE,
    referee_organization_id: organizationId,
    referee_acceptance: 'pending',
    status: 'active',
    sort_by: 'created_at',
    sort_direction: 'desc',
  };
}

export function buildWaitingOnRefereeSearchParams(
  organizationId: string,
  page: number
): ReferralSearchDTO {
  return {
    page,
    limit: PENDING_REFERRAL_TASK_PAGE_SIZE,
    referrer_organization_id: organizationId,
    referrer_acceptance: 'accepted',
    referee_acceptance: 'pending',
    status: 'active',
    sort_by: 'created_at',
    sort_direction: 'desc',
  };
}

export function toPendingReferralTasks(
  kind: PendingReferralTaskKind,
  referrals: ReferralDTO[]
): PendingReferralTask[] {
  return referrals.map((referral) => ({ kind, referral }));
}

export function toPendingCommissionTasks(
  commissions: PendingCommissionDTO[]
): PendingCommissionTask[] {
  return commissions.map((commission) => ({
    kind: 'commission_due',
    commission,
  }));
}

export function hasMorePendingReferralTaskPages(
  loaded: number,
  total: number,
  nextPage: number
): boolean {
  const maxPages = Math.ceil(total / PENDING_REFERRAL_TASK_PAGE_SIZE);
  return loaded < total && nextPage <= maxPages;
}
